import "./App.css";
import AppRouter from "./routers/Routers";

function App() {
  return (
    <>
      <AppRouter />
    </>
  );
}

export default App;
